import { z } from 'zod'

export const SearchSchema = z.object({
    regionType: z.string().optional(),
    regionId: z.number().optional(),
    explanationType: z.string().optional(),
    status: z.number().optional(),
    isRecommended: z.number().optional(),
    page: z.number().default(1),
    size: z.number().default(10),
})

export type Search = z.infer<typeof SearchSchema>
